import { TrlPillAnulPending } from './TrlPillAnulPending';

export { TrlPillAnulPending } from './TrlPillAnulPending';
export default TrlPillAnulPending;
